import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "hero", "supa", "size"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React from 'react';
import PropTypes from 'prop-types';
import { SuperHero, Hero, BaseHeadline } from "./headline.styles";
import { jsx as _jsx } from "react/jsx-runtime";
export var SIZES = {
  SMALL: 0,
  MEDIUM: 1,
  LARGE: 2
};
export var DEFAULT_SIZE = SIZES.MEDIUM;
export var Headline = function Headline(_ref) {
  var children = _ref.children,
    hero = _ref.hero,
    supa = _ref.supa,
    size = _ref.size,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (supa && hero) {
    return /*#__PURE__*/_jsx(SuperHero, _objectSpread(_objectSpread({}, rest), {}, {
      children: children
    }));
  }
  if (hero) {
    return /*#__PURE__*/_jsx(Hero, _objectSpread(_objectSpread({}, rest), {}, {
      children: children
    }));
  }
  return /*#__PURE__*/_jsx(BaseHeadline, _objectSpread(_objectSpread({}, rest), {}, {
    size: size,
    children: children
  }));
};
Headline.propTypes = {
  children: PropTypes.node,
  as: PropTypes.string,
  hero: PropTypes.bool,
  supa: PropTypes.bool,
  inverted: PropTypes.bool,
  size: PropTypes.oneOf(Object.values(SIZES))
};
Headline.defaultProps = {
  as: undefined,
  hero: false,
  supa: false,
  inverted: false,
  children: null,
  size: DEFAULT_SIZE
};